import React from "react";
import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { ChevronLeft, ExternalLink } from "lucide-react";
import { motion } from "framer-motion";

const TESTS = [
  { title: "Syndrome de l'imposteur", desc: "Avez-vous tendance à douter de votre légitimité, même quand les faits prouvent le contraire ?", url: "https://lyndabrybonnard.fr/test-avez-vous-le-syndrome-de-l-imposteur/" },
  { title: "Savez-vous dire non ?", desc: "Repérez si poser vos limites est un point de travail pour vous.", url: "https://lyndabrybonnard.fr/test-savez-vous-dire-non/" },
  { title: "Manger ses émotions", desc: "L'alimentation émotionnelle vous concerne-t-elle ?", url: "https://lyndabrybonnard.fr/test-est-ce-que-je-mange-mes-emotions/" },
  { title: "Addiction aux écrans", desc: "Votre rapport aux réseaux sociaux et aux écrans est-il sain ?", url: "https://lyndabrybonnard.fr/test-etes-vous-addict-aux-ecrans-reseaux-sociaux/" },
];

export default function TestsPage() {
  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <Link to="/dashboard" className="text-sm text-[#6A7771] hover:text-[#6B8576] flex items-center gap-1 mb-6 transition-colors duration-200">
          <ChevronLeft className="w-4 h-4" strokeWidth={1.5} /> Retour
        </Link>

        <div className="mb-8">
          <h1 className="text-3xl font-semibold text-[#2C3531] mb-2" style={{ fontFamily: 'Outfit' }} data-testid="tests-title">Tests</h1>
          <p className="text-[#6A7771] text-sm">Mieux se connaître, c'est déjà avancer. Ces tests sont hébergés sur le site de votre thérapeute.</p>
        </div>

        <div className="space-y-3">
          {TESTS.map((test, i) => (
            <motion.a key={i} href={test.url} target="_blank" rel="noopener noreferrer"
              initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              className="flex items-center gap-4 bg-white border border-[#EBE7E0] rounded-2xl p-5 hover:shadow-[0_8px_30px_rgba(44,53,49,0.08)] hover:border-[#6B8576]/20 transition-all duration-300 group"
              data-testid={`test-card-${i}`}
            >
              <div className="w-10 h-10 bg-[#D9A892]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <span className="text-[#D9A892] text-xs font-semibold">{i + 1}</span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-[#2C3531]" style={{ fontFamily: 'Outfit' }}>{test.title}</h3>
                <p className="text-xs text-[#6A7771] mt-0.5">{test.desc}</p>
              </div>
              <ExternalLink className="w-4 h-4 text-[#6A7771] group-hover:text-[#6B8576] transition-colors duration-200 flex-shrink-0" strokeWidth={1.5} />
            </motion.a>
          ))}
        </div>
      </main>
    </div>
  );
}
